import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    alignItems: 'center',
  },

  rewardLottieViewStyle: {
    width: 150,
    height: 150,
  },
  titleStyle: theme => ({
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: 30,
    color: theme.colors.textColorThree,
    textAlign: 'center',
  }),
  subTitle: theme => ({
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0,
    color: theme.colors.textColorThree,
    textAlign: 'center',
    marginTop: 8,
  }),
  addDataButton: { width: 93, height: 30, marginTop: 20, marginBottom: 60 },

  addDataButtonStyle: {
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center',
  },

  summaryTitleContainer: { alignSelf: 'stretch' },
  summaryTitleText: theme => ({
    fontSize: 24,
    lineHeight: 30,
    color: theme.colors.textColorThree,
    fontFamily: Fonts.type.VodafoneLt,
    fontWeight: 'normal',
    marginBottom: 16,
  }),
  summaryDetailsContainer: theme => ({
    paddingVertical: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorSix,
  }),
});
